import { generatePath, useRouteMatch } from "react-router-dom";
import { useIsTemplatesForBasicEmailEditorEnabled } from "@/react/components/SettingsApp/Emails/hooks/useIsTemplatesForBasicEmailEditorEnabled";
import { useTemplatesExists } from "@/react/components/shared/Emails/Templates/hooks/useTemplatesExists";

export const useBroadcastContentPath = () => {
  const { path, params } = useRouteMatch();
  const contentPath = `${path}/send-email/:broadcastId`;
  const templatesListPath = `${contentPath}/templates`;
  const isTemplatesForBasicEmailEditorEnabled =
    useIsTemplatesForBasicEmailEditorEnabled();
  const { doesTemplatesExist } = useTemplatesExists();

  const getPathToContentEditor = ({
    hasEmailContent,
    broadcastId,
  }: {
    hasEmailContent: boolean;
    broadcastId: number;
  }) => {
    /** This logic is repeated on Broadcast Content block. However the paths being routed to are completely different */
    if (
      isTemplatesForBasicEmailEditorEnabled &&
      doesTemplatesExist &&
      !hasEmailContent
    ) {
      return generatePath(templatesListPath, {
        broadcastId,
        ...params,
      });
    }
    return generatePath(contentPath, {
      broadcastId,
      ...params,
    });
  };

  return {
    getPathToContentEditor,
    contentPath,
  } as const;
};
